import type * as React from 'react';
import styled from 'styled-components';

import {
  mediaConfinedNavlessOnly,
  mediaSmallOrTiny,
} from '@xing-com/layout-tokens';
import { scale090, spaceL } from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

export const FooterSection: React.FC<{
  title: string;
  children: React.ReactNode;
}> = ({ title, children }) => (
  <LinkGroup>
    <Headline size="small" as="p">
      {title}
    </Headline>
    <FooterNav>{children}</FooterNav>
  </LinkGroup>
);

export const FooterSectionPlaceholder = styled.li`
  flex: 1 1 20%;
`;

const LinkGroup = styled(FooterSectionPlaceholder)`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const FooterNav = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  @media ${mediaSmallOrTiny} {
    padding-inline: ${spaceL};
  }

  @media ${mediaConfinedNavlessOnly} {
    padding-inline: ${scale090};
  }
`;
